export default [
    {
        title: 'menu.semence',
        icon: ['fal', 'vials'],
        accessRights: 'CASMNC',
		to: { name: 'semenceStallions' },
        mobile: true,
        desktop: true,
        home: true
    }
]
